import type { ActionCodeSettings } from 'firebase/auth';
import { env } from './env';

/** Where "Continue" in an auth email leads once the action is done (D34). */
export function actionCodeSettings(path = '/login'): ActionCodeSettings {
  const origin = (env.publicUrl || window.location.origin).replace(/\/+$/, '');
  return { url: `${origin}${path}` };
}

const CONTINUE_URL_REFUSED = ['auth/unauthorized-continue-uri', 'auth/invalid-continue-uri'];

/**
 * Sends an auth email with a continue URL, and again without one if Firebase refuses the URL
 * (an origin missing from Authorized domains, e.g. `127.0.0.1` with `dev:live`). The email
 * matters more than the "Continue" button.
 */
export async function sendWithContinueUrl(
  send: (settings?: ActionCodeSettings) => Promise<void>,
  path = '/login',
): Promise<void> {
  try {
    await send(actionCodeSettings(path));
  } catch (err) {
    if (!CONTINUE_URL_REFUSED.includes((err as { code?: string }).code ?? '')) throw err;
    await send();
  }
}
